import { useFormContext } from "react-hook-form";
import { useLastValidValues } from "../../utils/form/useLastValidValues.esm.js";
import { COMMON_AMOUNT_CONFIG } from "../../utils/zhl-calculator.esm.js";
const FieldConfig = {
  desiredSellingPrice: {
    name: "desiredSellingPrice",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  remainingMortgageOwed: {
    name: "remainingMortgageOwed",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  homeImprovement: {
    name: "homeImprovement",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  cleaningAndPrep: {
    name: "cleaningAndPrep",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  monthlyMortgagePayments: {
    name: "monthlyMortgagePayments",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  moving: {
    name: "moving",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  agentCommission: {
    name: "agentCommission",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  sellingConcessions: {
    name: "sellingConcessions",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  closingFees: {
    name: "closingFees",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  taxes: {
    name: "taxes",
    config: {
      ...COMMON_AMOUNT_CONFIG
    }
  },
  estimatedSellingCost: {
    name: "estimatedSellingCost"
  }
};
const validateAndTrackOptionsBlock = {
  shouldDirty: true,
  shouldTouch: true,
  shouldValidate: true
};
function getHomeSaleProceedsValues(lastValidFields) {
  const {
    desiredSellingPrice,
    remainingMortgageOwed,
    homeImprovement,
    cleaningAndPrep,
    monthlyMortgagePayments,
    moving,
    agentCommission,
    sellingConcessions,
    closingFees,
    taxes
  } = lastValidFields;
  const estimatedSellingCost = homeImprovement + cleaningAndPrep + monthlyMortgagePayments + moving + agentCommission + sellingConcessions + closingFees + taxes;
  const estimatedNetProceeds = desiredSellingPrice - estimatedSellingCost - remainingMortgageOwed;
  const estimatedSellingCostPercentage = Math.round(estimatedSellingCost / desiredSellingPrice * 1e4) / 100;
  const calculations = {
    estimatedSellingCostResult: estimatedSellingCost,
    estimatedNetProceeds,
    estimatedSellingCostPercentage
  };
  const values = {
    fields: lastValidFields,
    calculations
  };
  return values;
}
function useLastValidHomeSaleProceedsCalculator() {
  const form = useFormContext();
  return useLastValidValues(form, getHomeSaleProceedsValues);
}
export {
  FieldConfig,
  useLastValidHomeSaleProceedsCalculator,
  validateAndTrackOptionsBlock
};
